// @flow @format
export {default} from './Logo';



// WEBPACK FOOTER //
// ./src/components/Logo/index.js